module.exports = __webpack_public_path__ + "static/media/game-illusionization_cover.5ffd8f46.jpg";